// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__B9Leh","button":"Footer_button__3WM0e","footerLinkWrap":"Footer_footerLinkWrap__8e2L3","footerLinks":"Footer_footerLinks__1Fc46"};